/**
 * @module state.warranty
 * @property {Boolean} created True if the sinister is created. Application
 *  flow changes based on this parameter.
 * @property {String} sinisterId Sinister id.
 * @property {String} secondaryId Secondary id.
 * @property {String} address Sinister address.
 * @property {String} zipCode Sinister zip code.
 * @property {Object} coordinates Sinister address coordinates.
 * @property {String} coordinates.lat Sinister address lat coordinate.
 * @property {String} coordinates.lng Sinister address lng coordinate.
 * @property {Boolean} moreThanTwoYears True if sinister is older than two years.
 * @property {String} propertyType Sinister property type.
 * @property {String} residentType Sinister resident type.
 * @property {Array} sinisterSummary Sinister damages summary got from backend.
 * @property {Object} materialSummary Sinister material summary got from backend.
 * @property {Objet} report Sinister report stored in state, got from backend after
 * @property {String} heightArea Value of height input.
 * @property {String} widthArea Value of width input.
 * @property {String} unitArea Value of width input.
 * @property {String} showExtraInfo Value of width input.
 *  triggering sinister analysis.
 */
const getDefaultState = () => ({
  created: false,
  sinisterId: null,
  secondaryId: null,
  address: null,
  zipCode: null,
  coordinates: null,
  moreThanTwoYears: true,
  propertyType: 'appartement',
  residentType: 'propietarie',
  showExtraInfo: null,
  sinisterSummary: [],
  materialSummary: {},
  piecesSurface: [],
  lastPieceSelected: {},
  report: null,
  repairType: null,
  heightArea: 'Höhe',
  widthArea: 'Breite',
  unitArea: 'm',
  existingSinister: false,
  answeredExtraInfo: false
})

export { getDefaultState }
